import { ImageElement } from '@kontent-ai/gatsby-components';
import tw from 'twin.macro';

// NOTE: This is a workaround
// Allows useClickOutside to work as expected because clicking on the image is counted as outside which is not wanted.
export const StyledImage = tw(ImageElement)`pointer-events-none`;
